import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SALEMETHOD_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SaleMethod.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('value', 'Entity.SaleMethod.Value')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
];

export const SALEMETHOD_CONFIG = {
  entityName: 'SaleMethod',
  localizationKey: 'Controlling::Entity.SaleMethod',
  fields: SALEMETHOD_FIELDS,
  permission: 'ControllingLiquidations.SaleMethods',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
